// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","footer__item":"footer_footer__item__PqSq-","footer__link":"footer_footer__link__3sBUb","footer__list":"footer_footer__list__+oHoW"};